module.exports = __webpack_public_path__ + "img/pr-5.231a432c.png";